// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__qFW6Q","container":"DefaultLayout_container__quKgA","content":"DefaultLayout_content__D9X-2"};